<template>
  <div
    id="videoApp"
    class="footer-sticky-wrapper"
    :style="appStyle"
  >
    <router-view />
    <Footer v-if="!noFooter" />
  </div>
</template>

<script>
import { mapState } from 'vuex';

import Footer from './common/components/Footer.vue';
import { uigsClPb } from './common/js/clickPb';
import { getBottomParams } from './common/js/util';

export default {
  components: {
    Footer,
  },
  computed: {
    ...mapState('common', ['$config', 'loadingFinished']),
    appStyle() {
      const { $config = {}, loadingFinished = true } = this;
      const spver = this.$route.query.spver || 0;
      const heightRst = $config.noHead ? 0 : 105;
      const isHome = this.$route.name === 'home';
      const paddingRst = !isHome && loadingFinished && +spver === 0 ? 115 : 0;
      return `min-height: calc(100% - ${heightRst}px); padding-bottom: ${paddingRst}px;`;
    },
    noFooter() {
      return ['home', 'qlist', 'hotsugg', 'error', 'savideo'].indexOf(this.$route.name) > -1;
    },
  },
  beforeMount() {
    const { guid = '', qimei36 = '' } = this.$config || {};
    const addParams = {
      qimei36,
      guid,
    };
    this.$uigs.add(addParams);
    this.$uigsKd.add(addParams);
  },
  mounted() {
    const self = this;
    let clientHeight = 0;
    let scrollHeight = 0;
    let scrollTop = 0;
    let flag = true;

    // 全局点击日志上报
    document.onclick = function (e) {
      const params = uigsClPb(e);
      if (params && params.uigs_cl) {
        self.$uigs.send(params);
      }
    };

    // 全局滚动到底部
    window.addEventListener('scroll', () => {
      if (flag) {
        clientHeight = self.document().clientHeight;
        scrollHeight = self.document().scrollHeight;
        scrollTop = self.document().scrollTop;
        if (clientHeight > 100 && scrollHeight - clientHeight - scrollTop < 100) {
          flag = false;
          self.$uigs.send(getBottomParams());
        }
      }
    });

    // const { guid, wuid } = this.$config || {};
    // const uin = guid || wuid || Date.now();
    // window.aegis && window.aegis.setConfig({
    //   uin,
    // });
  },
  methods: {
    document() {
      return document.compatMode && 'BackCompat' !== document.compatMode ? document.documentElement : document.body;
    },
  },
};
</script>

<style lang="scss">
@import '../asset/css/main.scss';

.footer-sticky-wrapper {
  position: relative;
  box-sizing: border-box;
  .wap-footer {
    position: absolute;
    bottom: 0;
    width: 100%;
    box-sizing: border-box;
  }
}
</style>
